<template>
  <div class="relative w-full">
    <div class="w-full">
      <splide
        :options="options"
        has-slider-wrapper
      >
        <splide-slide
          v-for="review in reviews"
          :key="review.uuid"
        >
          <vetster-review-slider-tile
            :v-key="`review-${review.uuid}`"
            :review="review"
            class="mx-4 my-4"
          />
        </splide-slide>
      </splide>
    </div>
  </div>
</template>

<script>
// Package "@splidejs/vue-splide" installs the below file, ESLint is wrong.
// eslint-disable-next-line import/no-extraneous-dependencies
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import Splide from '@/components/Splide/Splide';
import SplideSlide from '@/components/Splide/SplideSlide';
import VetsterReviewSliderTile from '@/components/VetsterReviewSliderTile';

export default {
  name: 'VetsterReviewSlider',

  components: {
    Splide,
    SplideSlide,
    VetsterReviewSliderTile,
  },

  props: {
    reviews: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      options: {
        speed: 16000,
        interval: 0,
        keyboard: false,
        drag: false,
        pagination: false,
        type: 'loop',
        easing: 'linear',
        rewind: true,
        autoWidth: true,
        perMove: 1,
        autoplay: true,
        pauseOnHover: false,
        arrows: false,
      },
    };
  },
};
</script>
